import { constants } from "@newsela/angelou";

const greyLight = constants.colors.ui.neutral[100];

export const formBlockCss = {
  paddingBottom: "20px",
  borderBottom: "1px solid" + greyLight,
};

export const subTitleCss = {
  fontSize: "20px",
  lineHeight: "24px",
  fontWeight: "700",
};

export const inputCss = {
  label: {
    "& > div > label > svg": {
      display: "none" as const,
    },
  },
};
